<template>
  <div class="content-wrapper menu-item">
    <div class="menu-item-title">
      <div
        class="menu-item-title-thumbnail"
        :style="{
          'background-image': `url(${get(
            menu,
            'menuImages[0].imageUrl',
            require('@/assets/images/slide-img-placeholder.png')
          )})`
        }"
      />
      <div class="menu-item-title-box">
        <div class="flex justify-between items-center mb-2 relative">
          <div class="flex items-center gap-x-2 sm:flex-col sm:items-start sm:mr-8">
            <Tag type="primary" outline size="small" v-if="categoryName(menu)" class="whitespace-normal leading-3 tag-padding text-justify">
              {{ categoryName(menu) }}
            </Tag>
            <a
              class="text-black text-xs whitespace-nowrap sm:mt-2"
              @click="goToMenuDetail(menu.menuNo)"
              v-if="menu && menu.menuNo"
            >
              [メニューNo.{{ menu.menuNo }}]
            </a>
          </div>
          <!-- ライフエール独自対応 -->
          <a
            class="icon text-xl absolute right-0 top-0"
            :class="
              !get(menu, 'favourite.favourite', false)
                ? 'icon-bor-heart-plus'
                : 'icon-bor-heart-solid'
            "
            style="color: #da291c"
            @click="onFavourite(menu)"
          />
        </div>
        <h1 v-if="menu && menu.menuNm">
          <a
            v-html="menu.menuNm.replaceAll('\n', '<br>')"
            class="text-black text-epip title-menu"
            @click="goToMenuDetail(menu.menuNo)"
          />
        </h1>
        <div class="menu-item-title-rating">
          <!--                    <div class="flex flex-row bs-rating">-->
          <!--                      <Rating :rate="3.8" />-->
          <!--                    </div>-->
          <div class="flex gap-x-4">
            <!--                      <a href="#">クチコミ 189件</a>-->
            <div class="font-bold text-base">
              <span class="icon icon-bor-heart" @click="onFavourite(menu)" />
              {{ formatCurrency(get(menu, 'favourite.quantity', 0), '') }}件
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-divider class="hidden sm:block mt-2" />
    <div class="menu-item-detail">
      <div class="menu-item-detail-thumbnail">
        <BasicCarouselSearch
          class="mb-4"
          :images="menu.menuImages"
          :showLabel="true"
          :imageSmallest="true"
          :isShowIndicator="false"
          :numberThumbnail="5"
        />
      </div>
      <div class="menu-item-detail-wrapper">
        <div class="flex gap-x-2 mb-2" v-if="!isPublicStay">
          <p>
            {{ menu.planData.length ? calculateRoomPrice(menu.planData) : '' }}
          </p>
        </div>
        <div>
          <h2
            class="title text-epip mb-2"
            v-if="menu && menu.catchCopy"
            v-html="menu.catchCopy.replaceAll('\n', '<br>')"
          ></h2>
          <span
            class="sub-title text-epip"
            v-if="menu && menu.leadCopy"
            v-html="menu.leadCopy.replaceAll('\n', '<br>')"
          ></span>
        </div>
        <a-divider class="my-4" />
        <div class="address">
          <span v-if="getAreaName(menu)" class="icon icon-bor-pin mt-2" />
          <span class="mt-1">
            {{ getAreaName(menu) }}
          </span>
          <button
            v-if="getLatLong(menu)"
            class="c-btn btn-sm btn-white"
            @click="gotoMap(menu.areaInfomation.latitude, menu.areaInfomation.longitude)"
          >
            地図を見る
          </button>
        </div>
      </div>
    </div>

    <!--Category Stay-->
    <template v-if="filterForm.category === 'stay'">
      <a-divider />
      <section class="p-0">
        <div
          class="suggest-item"
          v-for="(plan, index) in menu.planData"
          :key="`menu-plan2-${index}`"
          v-show="!planLoading"
        >
          <!--Desktop-->
          <div class="sm:hidden">
            <div class="flex justify-between items-center mb-2">
              <h2 class="content-title">
                <a class="text-black text-epip" @click="gotoPlanDetail(plan)">
                  {{ get(plan, 'planBasicInfo.planNm') }}
                </a>
              </h2>
              <Tag class="suggest-item-tag">
                {{ getSymbolPlan(plan) }}
              </Tag>
            </div>
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-x-4">
                <img
                  src="@/assets/images/recomment-rakuten.png"
                  alt=""
                  v-if="get(plan, 'menuInformation.extImpSysCd') === 'RakutenT'"
                />
                <img src="@/assets/images/bene-log.png" alt="" v-else />
                <div class="flex items-center gap-x-4">
                  <i class="icon icon-bor-food"></i>
                  {{ roomEatServiceText(plan) }}
                </div>
              </div>
              <div class="suggest-item-price">{{ getPricePlan(plan) }}～</div>
            </div>
          </div>

          <!--Mobile-->
          <div class="hidden sm:flex flex-col">
            <div class="flex flex-col">
              <h2 class="content-title my-2">
                <a class="text-black text-epip" @click="gotoPlanDetail(plan)">
                  {{ get(plan, 'planBasicInfo.planNm') }}
                </a>
              </h2>
              <div class="flex items-center gap-x-4">
                <img
                  src="@/assets/images/recomment-rakuten.png"
                  alt=""
                  v-if="get(plan, 'menuInformation.extImpSysCd') === 'RakutenT'"
                />
                <img src="@/assets/images/bene-log.png" alt="" v-else />
                <div class="flex items-center gap-x-4">
                  <i class="icon icon-bor-food"></i>
                  {{ roomEatServiceText(plan) }}
                </div>
              </div>
            </div>
            <div class="flex justify-end items-center my-3">
              <Tag class="suggest-item-tag mr-2">
                {{ getSymbolPlan(plan) }}
              </Tag>
              <div class="suggest-item-price">{{ getPricePlan(plan) }}～</div>
            </div>
          </div>

          <a-divider />
        </div>
        <div class="flex justify-center py-8">
          <a-spin v-show="planLoading" />
        </div>
      </section>

      <section class="sm:p-0">
        <div class="footer">
          <span class="font-bold footer-count">
            合計{{ menu.planCount }}件の宿泊プランがあります。
          </span>
          <a-button color="#222222" @click="goToPlanList(menu.menuNo)">
            料金・宿泊プラン一覧を見る
          </a-button>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { get, isNil, isEmpty, minBy } from 'lodash'
import moment from 'moment'
import menu_utils from '@/mixins/menu_utils'
import func_utils from '@/mixins/func_utils'
import { DELETE_FAVORITE, SAVE_FAVORITE } from '@/store/modules/bs_myp/actions'

export default {
  name: 'SearchMenuItem',
  props: ['menu', 'isPublicStay', 'filterForm'],
  mixins: [menu_utils, func_utils],
  data() {
    return {
      planLoading: false
    }
  },
  async created() {},
  async mounted() {
    this.getPlans()
  },
  methods: {
    get,
    async getPlans() {
      console.log("in", this.menu)
      if (Array.isArray(this.menu.plans)) {
        const query = {
          adultHeadCnt: this.filterForm.numPeople
        }
        const { checkInDate, stayNights } = this.filterForm
        if (checkInDate) {
          query.checkInDay = moment(checkInDate).format('YYYY/MM/DD')
          query.checkOutDay = moment(checkInDate)
            .clone()
            .add(stayNights || 1, 'days')
            .format('YYYY/MM/DD')
        } else {
          query.designatedMo = '0';
        }

        let processes = []
        let response = []

        this.menu.plans.forEach((plan) => {
          const process = this.$repositories('plan').getPlanDetailForSearch(
            this.menu.menuNo,
            plan.planId,
            plan.roomId,
            query
          )
          processes.push(process)
        })

        this.planLoading = true
        response = (await Promise.allSettled(processes))
          .filter((item) => item.value)
          .map((el) => {
            return el.value
          })
        this.menu.planData = response
        this.planLoading = false
      }
    },
    onFavourite(item) {
      if (!this.$auth.loggedIn) {
        this.$modal.open("LoginGuidanceModal");
        return
      }

      const isFavourite = get(item, 'favourite.favourite', false)
      if (isFavourite) {
        this.$store.dispatch(DELETE_FAVORITE, item.favourite.id).then(
          () => {
            this.getFavoriteStatus(item.menuNo).then(
              (result) => {
                item.favourite.id = get(result, 'id', '')
                item.favourite.favourite = get(result, 'favourite', false)
                item.favourite.quantity = get(result, 'quantity', 0)
              },
              () => {}
            )
          },
          (err) => {
            const error = err.error
            this.$toasted.error(error && error.message ? error.message : error)
          }
        )
      } else {
        this.$store
          .dispatch(SAVE_FAVORITE, {
            itemType: 'favourite',
            menuNo: item.menuNo
          })
          .then(
            () => {
              this.getFavoriteStatus(item.menuNo).then(
                (result) => {
                  item.favourite.id = get(result, 'id', '')
                  item.favourite.favourite = get(result, 'favourite', false)
                  item.favourite.quantity = get(result, 'quantity', 0)
                },
                () => {}
              )
            },
            (err) => {
              const error = err.error
              this.$toasted.error(error && error.message ? error.message : error)
            }
          )
      }
    },
    categoryName(item) {
      let categoryNm = ''
      if (get(item, 'categoryInfomation.catLrgClassNm')) {
        categoryNm += get(item, 'categoryInfomation.catLrgClassNm')
      }
      if (get(item, 'categoryInfomation.catMidClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += get(item, 'categoryInfomation.catMidClassNm')
      }
      if (get(item, 'categoryInfomation.catSmlClassNm')) {
        if (categoryNm) {
          categoryNm += '・'
        }
        categoryNm += get(item, 'categoryInfomation.catSmlClassNm')
      }
      return categoryNm
    },
    getAreaName(item) {
      const areaMidClassNm = get(item, 'areaInfomation.areaMidClassNm', '')
      const areaDtlClassNm = get(item, 'areaInfomation.areaDtlClassNm', '')

      if (areaMidClassNm && areaDtlClassNm) {
        return `${areaMidClassNm} > ${areaDtlClassNm}`
      }
      if (areaMidClassNm && !areaDtlClassNm) {
        return `${areaMidClassNm}`
      }
      if (!areaMidClassNm && areaDtlClassNm) {
        return `${areaDtlClassNm}`
      }
      return ''
    },
    getLatLong(item) {
      const lat = get(item, 'areaInfomation.latitude', '')
      const long = get(item, 'areaInfomation.longitude', '')
      return !!(lat && long)
    },
    calculateRoomPrice(plans) {
      let calendar
      const data = (plans || []).reduce((acc, plan) => {
        if (!this.filterForm.checkInDate) {
          // 日付未指定の場合
          calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
          } else {
          calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
            (item) => item.stayDay === this.currentDay
          )
        }
        if (calendar) {
          return [...acc, calendar]
        }
        return acc
      }, [])

      const firstDataParent = data[0] || {}
      let firstData;
      if (Array.isArray(firstDataParent)) {
        firstData = firstDataParent[0] || {}
      } else {
        firstData = firstDataParent || {}
      }
      const hasRoomPrice = !isNil(firstData?.roomPrice)
      let minPrice = hasRoomPrice ? firstData?.roomPrice : firstData?.price || 0
      if (data.length) {
        data.forEach((items) => {
          if (Array.isArray(items)) {
            items.forEach((item) => {
              const price = hasRoomPrice ? +item.roomPrice : +item.price
              if (minPrice >= price) minPrice = price
            })
          } else {
            const price = hasRoomPrice ? +items.roomPrice : +items.price
            if (minPrice >= price) minPrice = price
          }
        })
      }
      minPrice = this.formatCurrency(minPrice || this.pricePlan)
      
      minPrice = minPrice ? minPrice : '';

      return hasRoomPrice ? `${minPrice}／室` : `${minPrice}/人`
    },
    getSymbolPlan(plan) {
      if (!this.filterForm.checkInDate) {
        // 日付未指定の場合
        const calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
        return !isNil(calendar?.roomPrice) ? '1泊の料金' : '大人1人'
      } else {
        const calendar =
          get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
            (calendar) => calendar.stayDay === this.currentDay
          ) || {}
        return !isNil(calendar?.roomPrice) ? '1泊の料金' : '大人1人'
      }
    },
    roomEatServiceText(plan) {
      const breakfastFlag = !!+get(plan, 'planUsage.usageDetailStay.breakfastFlag', false)
      const dinnerFlag = !!+get(plan, 'planUsage.usageDetailStay.dinnerFlag', false)
      if (breakfastFlag && dinnerFlag) {
        return '朝食・夕食つき'
      } else if (breakfastFlag) {
        return '朝食のみ'
      } else if (dinnerFlag) {
        return 'ディナーのみ'
      }
      return '朝食と夕食は含まれていません'
    },
    getPricePlan(plan) {
        // const calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
        let calendar;
        if (!this.filterForm.checkInDate) {
          // 日付未指定の場合
          calendar = get(plan, 'vacancyCalendar.vacancyCalendars', [])
        } else {
          try {
            calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
              (item) => item.stayDay === this.filterForm.checkInDate.format('YYYY/MM/DD')
            )
          } catch (e) {
            if (e instanceof TypeError) {
              calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []).find(
                (item) => item.stayDay == this.currentDay
              )
            }
          }
          if (calendar == null || (Array.isArray(calendar) && calendar.length == 0)) {
              calendar = get(plan, 'vacancyCalendar.vacancyCalendars', []);
            }
        }
        if (Array.isArray(calendar)) {
          const min = minBy(calendar, 'price');
          return this.formatCurrency(min?.price || '');
        } else {
          return this.formatCurrency(calendar?.price || '');
        }
    },
    goToMenuDetail(menuNo) {
      sessionStorage.setItem('previousUrl', JSON.stringify(this.$route.query))
      if (this.isPublicStay) {
        this.$router.push({
          path: `/public-stay/menus/${menuNo}`
        })
        return
      }
      const query = this.$route.query
      query.feeUpper = query.feeUpper === 0 ? query.feeUpper : 200000
      delete query.keyword
      this.$router.push({
        path: `/menus/${menuNo}`,
        query
      })
    },
    goToPlanList(menuNo) {
      const query = this.$route.query
      query.feeUpper = query.feeUpper === 0 ? query.feeUpper : 200000
      delete query.keyword
      this.$router.push({
        path: `/menus/${menuNo}/plans`,
        query
      })
    },
    gotoPlanDetail(item) {
      const menuNo = get(item, 'menuInformation.menuNo', '')
      const planId = get(item, 'planBasicInfo.planId', '')
      const roomId = get(item, 'roomBasicInfo.roomId', '')
      const query = this.$route.query
      delete query.keyword
      this.$router.push({
        path: `/menus/${menuNo}/plans/${planId}/rooms/${roomId}`,
        query
      })
    },
    gotoMap(latitude, longitude) {
      if (latitude !== null && longitude !== null) {
        window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
        return
      }
      window.open('https://maps.google.com')
    }
  },
  computed: {
    query() {
      return this.$route.query
    },
    currentDay() {
      const { checkInDate } = this.query
      if (!!checkInDate && moment(checkInDate).isValid()) {
        return moment(checkInDate).format('YYYY/MM/DD')
      }
      return moment().format('YYYY/MM/DD')
    },
    pricePlan() {
      const listVacancy = get(this.menu, 'planData[0].vacancyCalendar.vacancyCalendars')
      if (isEmpty(listVacancy)) return ''
      else {
        const currentCalendar = listVacancy?.find(
          (calendar) => calendar.stayDay === this.currentDay
        )
        if (!isEmpty(currentCalendar)) {
          let curentPrice = currentCalendar?.roomPrice ?? currentCalendar?.price
          return curentPrice || ''
        } else {
          const min = minBy(listVacancy, 'price')
          return min?.price || ''
        }
      }
    }
  },
  watch: {
    menu() {
      this.getPlans()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './publicStay.scss';
::v-deep .menu-item-detail-thumbnail {
  .b-carousel-image {
    min-height: unset;
  }
  .thumbnails > div {
    height: 40px;
  }
}

.menu-item-title-box {
  .tag-padding {
    padding: 3px 5px;
  }
}
</style>